import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { UserService } from '@app/shared/services/user.service';
import { map } from 'rxjs';

export const deregistrationsGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const router = inject(Router);

  return userService.fetchUser$.pipe(
    map((user) => user.access.deregistrations || router.parseUrl(''))
  );
};
